//IMPORT HEADER
import medpill_header from "./components/header";
//IMPORT FOOTER
import medpill_footer from "./components/footer";
//PARTICLES JS
import './assets/js/particles.js';
//PARALLAX JS
import './assets/js/parallax.js';
//OWL CAROUSEL JS
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

export default {
    name: 'App',

    created() {
        document.title = "Medpill | Multi Purpose Vue Js Landing Page";
    },
    components: {
        medpill_header,
        medpill_footer,
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.hidePreloader();
            this.windowScroll();
            this.initElementClick();
        },
        /*----ONSCROLL JS-----*/
        windowScroll() {
            var self = this;
            $(window).on("scroll", function () {
                self.initSectionScroll();
            });
        },
        /*----PRELOADER-----*/
        hidePreloader() {
            var preloaderFadeOutTime = 500;
            var preloader = $('.spinner-wrapper');
            setTimeout(function () {
                preloader.fadeOut(preloaderFadeOutTime);
            }, 500);
        },
       
        /*----Element Clicks -----*/
        initElementClick() {
            /*----Menu CLose Click -----*/
            $(".menu-close-btn").on("click", function () {
                $('.navbar-collapse').removeClass('show');
            });

            var viewPortWidth = jQuery(window).width();
            if (viewPortWidth < 991) {
                $(".m-close-menu").on("click", function () {
                    $('.navbar-collapse').removeClass('show');
                });
            }
            

        },
        /*----Section Scroll -----*/
        initSectionScroll() {
            var sections = $('section'),
                nav = $('.navbar-nav'),
                nav_height = nav.outerHeight() + 25,
                win_scroll_top = $(window).scrollTop();
            win_scroll_top >= 80 ? $("nav").addClass("sticky-header") : $(".sticky").removeClass("sticky-header");
            win_scroll_top > 100 ? $(".back_top").fadeIn() : $(".back_top").fadeOut()
        }

    }
}